// extracted by css-extract-rspack-plugin
export default {"radioGroup":"radioGroup-nhlRsR","vertical":"vertical-pR6FDS","horizontal":"horizontal-Ksm5bm"};